import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicFormComponent } from '../../dynamic-form/dynamic-form.component';

const EVENT_FORM_SETTINGS = {
  showNavigationButtons: true,
  navigationButtonsLocation: 'bottom',
  showEmptyFormSubmit: false,
  formDataSource: 'event_form_data',
};

@Component({
  selector: 'app-duna-add-event',
  standalone: true,
  imports: [DynamicFormComponent],
  templateUrl: './duna-add-event.component.html',
  styleUrl: './duna-add-event.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DunaAddEventComponent {
  readonly dynamicInput = {
    bundledSurveyForm: { type: 'text', value: 'add-event' },
    formReceiveFunction: { type: 'text', value: 'add_event' },
    surveyJSON: { type: 'surveyJSON', value: '{}' },
    settings: { type: 'json', value: EVENT_FORM_SETTINGS },
  };
}
